import { render, staticRenderFns } from "./bestAustralia.vue?vue&type=template&id=3d52d6a3&"
import script from "./bestAustralia.vue?vue&type=script&lang=js&"
export * from "./bestAustralia.vue?vue&type=script&lang=js&"
import style0 from "./bestAustralia.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports